import { Box, Breadcrumbs, Button, Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

import { NonAuthRoutes } from '../../../model'

import { useSelector } from 'react-redux'
import {
  selectActiveContract,
  selectClientData,
  selectIsFetchingClientContractsError
} from '../../../redux/selectors/client.selectors'

import Page from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import { BreadcrumbLink } from '../../../components/shared/breadcrumbLink/breadcrumbLink'
import { getLinkClientText } from '../../clients/client.helper'
import { FlexibilitiesCard } from './components/flexibilitiesCard'

export const ContractsFlexibilitiesPage: React.FC<{}> = () => {
  const [t] = useTranslation(['globalerisLibrary', 'clients', 'clientFile', 'enums'])
  const history = useHistory()

  const clientData = useSelector(selectClientData)
  const contractData = useSelector(selectActiveContract)
  const fetchingContractsError = useSelector(selectIsFetchingClientContractsError)

  const handleClickBackButton = () => {
    history.push(NonAuthRoutes.ClientFile, { clientID: clientData?.id })
  }

  return (
    <Page fullWidth={true}>
      <PageHeader title="Ficha de Cliente">
        <Button
          variant="text"
          color="primary"
          // disabled={isFetchingClient}
          onClick={handleClickBackButton}
        >
          {t('clients:searchPage.buttons.back')}
        </Button>
      </PageHeader>
      <PageCenterColumn>
        <Box mb={1}>
          <Breadcrumbs separator=">" aria-label="breadcrumb">
            {clientData && (
              <BreadcrumbLink toPathName="/client/file" state={{ clientID: clientData?.id }}>
                {`${t('clientFile:components.additionalsTab.client')} ${getLinkClientText(
                  clientData
                )} -
              ID ${clientData.documentID}`}
              </BreadcrumbLink>
            )}
            <Typography key="3" color="primary" variant="subtitle1">
              {t('clientFile:components.additionalsTab.contract')} {contractData?.contractCode}
            </Typography>
          </Breadcrumbs>
        </Box>
        <FlexibilitiesCard
          contract={contractData!}
          commodity={contractData?.commodity}
          onRetry={() => {}}
          error={fetchingContractsError}
        />
      </PageCenterColumn>
    </Page>
  )
}
